import request from '@/http/http'
const PREFIX = 'api/deer/reports';
//获取签约战报列表
export function getNetSignList(query) {
    return request({
        url: PREFIX + '/broker-NetSign-list',
        params: query
    })
}

// 获取报备环比(新增 + 环比)
export function getReportReservationRatio() {
    return request({
        url: PREFIX + '/reservation-ratio',
    })
}

//获取项目动态列表
export function getDynamicList(query) {
    return request({
        url: PREFIX + '/dynamic-list',
        params: query
    })
}

//获取分销商门店经纪人销售额排行
export function getBrokerRankList(query) {
    return request({
        url: PREFIX + '/broker-rank',
        params: query
    })
}
//获取分销商门店销售额排行
export function getStoreRankList(query) {
    return request({
        url: PREFIX + '/store-rank',
        params: query
    })
}

//获取楼盘销售量排行
export function getEstateRankList(query) {
    return request({
        url: PREFIX + '/estate-rank',
        params: query
    })
}

// 楼盘跟进排行
export function getEstateFollowRankList(query) {
    return request({
        url: PREFIX + '/estate-follow-rank',
        params: query
    })
}

//获取分销商当天统计信息
export function getChannelTodayStatistics(query) {
    return request({
        url: PREFIX + '/channel-today-statistics',
        params: query
    })
}

//获取案场当天统计信息
export function getConsultantTodayStatistics(query) {
    return request({
        url: PREFIX + '/consultant-today-statistics',
        params: query
    })
}
//获取店东当天统计信息
export function getStoreTodayStatistics(query) {
    return request({
        url: PREFIX + '/store-today-statistics',
        params: query
    })
}
//获取经纪人当天统计信息
export function getBrokerTodayStatistics(query) {
    return request({
        url: PREFIX + '/broker-today-statistics',
        params: query
    })
}
//获取当天报备统计信息
export function getTodayReservationStatistics(query) {
    return request({
        url: PREFIX + '/today-reservation-statistics',
        params: query
    })
}

//获取楼盘统计信息
export function getEstateStatistics(query) {
    return request({
        url: PREFIX + '/estate-statistics',
        params: query
    })
}
//日报
export function getEstateDailyStatistics(query) {
    return request({
        url: PREFIX + '/estate-daily-statistics',
        params: query
    })
}
//趋势
export function getEstateTrendStatistics(query) {
    return request({
        url: PREFIX + '/estate-trend-statistics',
        params: query
    })
}
//导出
export function getExportEstateStatistics(query) {
    return request({
        url: PREFIX + '/export-estate-statistics',
        params: query,
        responseType: 'blob'
    })
}
export function getExportEstateDailyStatistics(query) {
    return request({
        url: PREFIX + '/export-estate-daily-statistics',
        params: query,
        responseType: 'blob'
    })
}
//获取分销商门店统计信息
export function getStoreStatistics(query) {
    return request({
        url: PREFIX + '/store-statistics',
        params: query
    })
}
export function getStoreDailyStatistics(query) {
    return request({
        url: PREFIX + '/store-daily-statistics',
        params: query
    })
}
//趋势
export function getStoreTrendStatistics(query) {
    return request({
        url: PREFIX + '/store-trend-statistics',
        params: query
    })
}
//导出
export function getExportStoreStatistics(query) {
    return request({
        url: PREFIX + '/export-store-statistics',
        params: query,
        responseType: 'blob'
    })
}
export function getExportStoreDailyStatistics(query) {
    return request({
        url: PREFIX + '/export-store-daily-statistics',
        params: query,
        responseType: 'blob'
    })
}
//获取分销商统计信息
export function getChannelStatistics(query) {
    return request({
        url: PREFIX + '/channel-statistics',
        params: query
    })
}
export function getChannelDailyStatistics(query) {
    return request({
        url: PREFIX + '/channel-daily-statistics',
        params: query
    })
}
//趋势
export function getChannelTrendStatistics(query) {
    return request({
        url: PREFIX + '/channel-trend-statistics',
        params: query
    })
}
//导出
export function getExportChannelStatistics(query) {
    return request({
        url: PREFIX + '/export-channel-statistics',
        params: query,
        responseType: 'blob'
    })
}

export function getExportChannelDailyStatistics(query) {
    return request({
        url: PREFIX + '/export-channel-daily-statistics',
        params: query,
        responseType: 'blob'
    })
}

//获取经纪人统计信息
export function getBrokerStatistics(query) {
    return request({
        url: PREFIX + '/broker-statistics',
        params: query
    })
}
export function getBrokerDailyStatistics(query) {
    return request({
        url: PREFIX + '/broker-daily-statistics',
        params: query
    })
}
//趋势
export function getBrokerTrendStatistics(query) {
    return request({
        url: PREFIX + '/broker-trend-statistics',
        params: query
    })
}
//导出
export function getExportBrokerStatistics(query) {
    return request({
        url: PREFIX + '/export-broker-statistics',
        params: query,
        responseType: 'blob'
    })
}

export function getExportBrokerDailyStatistics(query) {
    return request({
        url: PREFIX + '/export-broker-daily-statistics',
        params: query,
        responseType: 'blob'
    })
}
